import React from 'react'
import { SectionWrapper } from '../../theme/layouts/MainLayout'
import { techBlack } from '../../common/utils/constant'
import "./style404.scss"

const title = "The page can't be found.";
const desc = "It looks like nothing was found at this location.";

function PageNotFound() {
    return (
        <div className='error-wrapper-page'>
            <SectionWrapper bg={techBlack}>
                <div className='error404-container'>
                    <h1 className='error-title'>{title}</h1>
                    <p className='error-desc'> {desc}</p>
                </div>
            </SectionWrapper>
        </div>
    )
}

export default PageNotFound